/** Appends locked users that are missing from a selected-user value. */
export const withLockedUserIds = (ids: readonly string[], lockedIds: readonly string[]): string[] => [
  ...ids,
  ...lockedIds.filter((id) => !ids.includes(id)),
];
